import { Text } from '@dixa/lib-shared-habla';

import { UserAuditLogEntry } from 'apis/auditLogs';

import { LineItems } from './lineItems';
import { SummaryItems } from './summaryItems';
import { UserActivityCard } from './userActivityCard';
import { statusColors } from './userActivityTypes.utils';

type OrderFulfilledProps = {
  entry: UserAuditLogEntry<'COMMERCE_ORDER_FULFILLED'>;
};

export const OrderFulfilled = ({ entry }: OrderFulfilledProps): JSX.Element => {
  // The fulfillment id doubles as the tracking link when a URL is present.
  // stopPropagation keeps a click on the link from also toggling the card.
  const fulfillmentId =
    entry.fulfillment_id && entry.tracking_url ? (
      <Text.ExternalLink
        href={entry.tracking_url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(event) => event.stopPropagation()}
      >
        {entry.fulfillment_id}
      </Text.ExternalLink>
    ) : (
      entry.fulfillment_id
    );

  return (
    <UserActivityCard
      entry={entry}
      icon="check-circle"
      color={statusColors.positive}
      title="Order fulfilled"
      summary={
        <SummaryItems
          items={[
            { key: 'order', content: entry.order_id, copyText: entry.order_id },
            {
              key: 'fulfillment',
              content: fulfillmentId,
              copyText: entry.fulfillment_id,
            },
          ]}
        />
      }
    >
      {entry.line_items?.length ? <LineItems items={entry.line_items} /> : null}
    </UserActivityCard>
  );
};
